import { PosSelect, PosSelectProps } from 'src/core/POS/PosSelect';
import { useUserGroups } from 'src/hooks/useUserGroups';

export const UserGroupSelector = ({
  ...props
}: Omit<PosSelectProps, 'valueOptionsContent'>) => {
  const { userGroups, isLoading } = useUserGroups();

  const userGroupsContentSelect = (userGroups ?? []).reduce<
    Record<string, string>
  >((acc, userGroup) => {
    acc[userGroup.userGroupId.toString()] = userGroup.userGroupName;
    return acc;
  }, {});

  return (
    <PosSelect
      {...props}
      loading={isLoading}
      valueOptionsContent={userGroupsContentSelect}
    />
  );
};
